var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.28857,
    y: 9.60181,
    width: 10.6687,
    height: 1.06687,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55615,
    y: 5.33447,
    width: 2.13374,
    height: 1.06687,
    fill: "#232323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55615 0H9.68989V1.06687H7.55615V0Z",
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48877,
    y: 1.06689,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42236,
    y: 2.13379,
    width: 1.06687,
    height: 2.13374,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48877,
    y: 4.26758,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.22168,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.28857,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.35498,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42236,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48877,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55615,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.62305,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9.68945,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7568,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8232,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8906,
    y: 13.8694,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13.957,
    y: 12.8025,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06687,
    height: 1.06687,
    transform: "matrix(-1 0 0 1 10.7568 1.06689)",
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06687,
    height: 2.13374,
    transform: "matrix(-1 0 0 1 11.8232 2.13379)",
    fill: "#232323"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06687,
    height: 1.06687,
    transform: "matrix(-1 0 0 1 10.7568 4.26758)",
    fill: "#232323"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48877,
    y: 6.40112,
    width: 1.06687,
    height: 3.20061,
    fill: "#232323"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9.68945,
    y: 6.40112,
    width: 1.06687,
    height: 3.20061,
    fill: "#232323"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0878906,
    y: 17.0698,
    width: 17.0699,
    height: 1.06687,
    fill: "#232323"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 2.22168,
    y: 10.6687,
    width: 1.06687,
    height: 1.06687,
    fill: "#232323"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1.15479,
    y: 11.7356,
    width: 1.06687,
    height: 5.33435,
    fill: "#232323"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06687,
    height: 1.06687,
    transform: "matrix(-1 0 0 1 15.0239 10.6687)",
    fill: "#232323"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06687,
    height: 5.33435,
    transform: "matrix(-1 0 0 1 16.0913 11.7356)",
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.205984d3ce295c26a518c65560c5534f.svg";
export { ForwardRef as ReactComponent };